// Russian Intermediate Vocabulary - 50 unique items
// Each item supports 5 question types: target↔english, target↔romanization, definition→target

import { VocabularyItem } from '../../../utils/multipleChoiceLogic';

export const russianIntermediateItems: VocabularyItem[] = [
  // Time & Calendar (1-10)
  {
    id: 'ru-int-001',
    target: 'Сегодня',
    english: 'Today',
    romanization: 'Segodnya',
    definition: 'The present day',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-002',
    target: 'Завтра',
    english: 'Tomorrow',
    romanization: 'Zavtra',
    definition: 'The day after today',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-003',
    target: 'Вчера',
    english: 'Yesterday',
    romanization: 'Vchera',
    definition: 'The day before today',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-004',
    target: 'Неделя',
    english: 'Week',
    romanization: 'Nedelya',
    definition: 'A period of seven days',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-005',
    target: 'Месяц',
    english: 'Month',
    romanization: 'Mesyats',
    definition: 'A period of about 30 days',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-006',
    target: 'Год',
    english: 'Year',
    romanization: 'God',
    definition: 'A period of 12 months',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-007',
    target: 'Час',
    english: 'Hour',
    romanization: 'Chas',
    definition: 'A period of 60 minutes',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-008',
    target: 'Минута',
    english: 'Minute',
    romanization: 'Minuta',
    definition: 'A period of 60 seconds',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-009',
    target: 'Сейчас',
    english: 'Now',
    romanization: 'Seychas',
    definition: 'At the present moment',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-010',
    target: 'Раньше',
    english: 'Before / Earlier',
    romanization: 'Ranshe',
    definition: 'At an earlier time',
    partOfSpeech: 'adverb'
  },

  // Places & Locations (11-20)
  {
    id: 'ru-int-011',
    target: 'Школа',
    english: 'School',
    romanization: 'Shkola',
    definition: 'A place for education and learning',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-012',
    target: 'Больница',
    english: 'Hospital',
    romanization: 'Bolnitsa',
    definition: 'A place for medical treatment',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-013',
    target: 'Магазин',
    english: 'Store / Shop',
    romanization: 'Magazin',
    definition: 'A place where goods are sold',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-014',
    target: 'Ресторан',
    english: 'Restaurant',
    romanization: 'Restoran',
    definition: 'A place to eat meals',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-015',
    target: 'Аэропорт',
    english: 'Airport',
    romanization: 'Aeroport',
    definition: 'A place where airplanes take off and land',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-016',
    target: 'Вокзал',
    english: 'Train station',
    romanization: 'Vokzal',
    definition: 'A place where trains stop for passengers',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-017',
    target: 'Банк',
    english: 'Bank',
    romanization: 'Bank',
    definition: 'A financial institution for money',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-018',
    target: 'Офис',
    english: 'Office',
    romanization: 'Ofis',
    definition: 'A place for business work',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-019',
    target: 'Кинотеатр',
    english: 'Cinema',
    romanization: 'Kinoteatr',
    definition: 'A place to watch movies',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-020',
    target: 'Библиотека',
    english: 'Library',
    romanization: 'Biblioteka',
    definition: 'A place with books for reading',
    partOfSpeech: 'noun'
  },

  // Weather & Nature (21-30)
  {
    id: 'ru-int-021',
    target: 'Погода',
    english: 'Weather',
    romanization: 'Pogoda',
    definition: 'The atmospheric conditions',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-022',
    target: 'Жарко',
    english: 'Hot (weather)',
    romanization: 'Zharko',
    definition: 'Having high temperature',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-023',
    target: 'Холодно',
    english: 'Cold (weather)',
    romanization: 'Kholodno',
    definition: 'Having low temperature',
    partOfSpeech: 'adverb'
  },
  {
    id: 'ru-int-024',
    target: 'Дождь',
    english: 'Rain',
    romanization: 'Dozhd',
    definition: 'Water falling from clouds',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-025',
    target: 'Снег',
    english: 'Snow',
    romanization: 'Sneg',
    definition: 'Frozen water falling from clouds',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-026',
    target: 'Солнце',
    english: 'Sun',
    romanization: 'Solntse',
    definition: 'The star that gives Earth light and heat',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-027',
    target: 'Ветер',
    english: 'Wind',
    romanization: 'Veter',
    definition: 'Moving air',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-028',
    target: 'Дерево',
    english: 'Tree',
    romanization: 'Derevo',
    definition: 'A tall plant with a trunk and branches',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-029',
    target: 'Цветок',
    english: 'Flower',
    romanization: 'Tsvetok',
    definition: 'The colorful part of a plant',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-030',
    target: 'Гора',
    english: 'Mountain',
    romanization: 'Gora',
    definition: 'A large natural elevation of land',
    partOfSpeech: 'noun'
  },

  // Food & Drink (31-40)
  {
    id: 'ru-int-031',
    target: 'Яблоко',
    english: 'Apple',
    romanization: 'Yabloko',
    definition: 'A round red or green fruit',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-032',
    target: 'Банан',
    english: 'Banana',
    romanization: 'Banan',
    definition: 'A long yellow curved fruit',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-033',
    target: 'Яйцо',
    english: 'Egg',
    romanization: 'Yaytso',
    definition: 'An oval object laid by hens',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-034',
    target: 'Молоко',
    english: 'Milk',
    romanization: 'Moloko',
    definition: 'White liquid from cows',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-035',
    target: 'Кофе',
    english: 'Coffee',
    romanization: 'Kofe',
    definition: 'A dark brown caffeinated drink',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-036',
    target: 'Суп',
    english: 'Soup',
    romanization: 'Sup',
    definition: 'A liquid dish made by boiling ingredients',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-037',
    target: 'Овощи',
    english: 'Vegetables',
    romanization: 'Ovoshchi',
    definition: 'Plants grown for food',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-038',
    target: 'Мясо',
    english: 'Meat',
    romanization: 'Myaso',
    definition: 'Flesh of animals as food',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-039',
    target: 'Рыба',
    english: 'Fish',
    romanization: 'Ryba',
    definition: 'An aquatic animal with fins',
    partOfSpeech: 'noun'
  },
  {
    id: 'ru-int-040',
    target: 'Сладкий',
    english: 'Sweet',
    romanization: 'Sladkiy',
    definition: 'Having a taste like sugar',
    partOfSpeech: 'adjective'
  },

  // Common Actions (41-50)
  {
    id: 'ru-int-041',
    target: 'Работать',
    english: 'To work',
    romanization: 'Rabotat',
    definition: 'Activity done for employment',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-042',
    target: 'Учить',
    english: 'To learn / To teach',
    romanization: 'Uchit',
    definition: 'To gain or impart knowledge',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-043',
    target: 'Спать',
    english: 'To sleep',
    romanization: 'Spat',
    definition: 'To rest in an unconscious state',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-044',
    target: 'Вставать',
    english: 'To get up',
    romanization: 'Vstavat',
    definition: 'To rise from bed after sleeping',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-045',
    target: 'Покупать',
    english: 'To buy',
    romanization: 'Pokupat',
    definition: 'To obtain something by paying money',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-046',
    target: 'Продавать',
    english: 'To sell',
    romanization: 'Prodavat',
    definition: 'To exchange goods for money',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-047',
    target: 'Звонить',
    english: 'To call (phone)',
    romanization: 'Zvonit',
    definition: 'To communicate using a telephone',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-048',
    target: 'Помогать',
    english: 'To help',
    romanization: 'Pomogat',
    definition: 'To assist or support someone',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-049',
    target: 'Ждать',
    english: 'To wait',
    romanization: 'Zhdat',
    definition: 'To stay in place for someone',
    partOfSpeech: 'verb'
  },
  {
    id: 'ru-int-050',
    target: 'Спрашивать',
    english: 'To ask',
    romanization: 'Sprashivat',
    definition: 'To request information',
    partOfSpeech: 'verb'
  }
];
